<template>
	<div class="purchase">
		<!-- <div @click="getPurchaserData()">{{$t('other.a945')}}按扭</div> -->
		<el-dialog :title="$t('sellerpurchase').warn" :visible.sync="dialogVisible" width="30%">
			<span>{{visiableMessage}}</span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="toreplace()">{{$t('sellerpurchase').I_know}}</el-button>
			</span>
		</el-dialog>
		<!-- 查看详情 -->
		<el-dialog :title="$t('sellerpurchase').Purchase_information" :visible.sync="dialogTableVisible" width="60%">
			<div  style="font-size:18px;margin-bottom:20px;color:red">{{$t('complaint.sellerLeaveMessage')}}：{{sellerMessage ? sellerMessage : description}}</div>
			<div  style="font-size:18px;margin-bottom:20px;color:red">{{$t('complaint.WarehouseLeaveMessage')}}：{{storeMessage ? storeMessage : description}}</div>
			<el-table :data="itemDetail" height="450px" border>
				<el-table-column width="80" :show-overflow-tooltip="true">
					<template slot-scope="images">
						<el-popover placement="top-start" title="" trigger="hover">
							<img :src=changeImgURL(images.row.image) alt="" style="width: 150px;height: 150px">
							<img slot="reference" :src=changeImgURL(images.row.image) style="width: 30px;height: 30px">
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column property="cusCode" :label="$t('sellerpurchase').cusCode" width="100" :show-overflow-tooltip="true"></el-table-column>
				<el-table-column property="itemName" :label="$t('sellerpurchase').name" width="300" :show-overflow-tooltip="true"></el-table-column>
				<el-table-column property="variantName" label="sku" width="100" :show-overflow-tooltip="true"></el-table-column>
				<el-table-column property="sellerQty" :label="$t('homeTwo.Sellerpurchasequantity')"  :show-overflow-tooltip="true"></el-table-column>
				<el-table-column property="variantNum" :label="$t('sellerpurchase.actualNo')"  :show-overflow-tooltip="true"></el-table-column>
			</el-table>
		</el-dialog>

		<!-- 打印条形码 -->
		<el-dialog :title="$t('processed.Barcodeprinting')" :visible.sync="barCodeTrue">
			<div>
				<el-button size="mini" type="primary" @click="getBarCode">{{$t('processed.Printcode')}}</el-button>
				<el-button size="mini" type="primary" @click="printPurchaseCode">{{$t('processed.Printentry')}}</el-button>
			</div>
			<el-table ref="multipleTable" :data="printDetail" height="450px" select-all="checkedall" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="50">
				</el-table-column>
				<el-table-column label="img" :show-overflow-tooltip="true">
					<template slot-scope="images">
						<el-popover placement="top-start" title="" trigger="hover">
							<img :src=changeImgURL(images.row.image) alt="" style="width: 150px;height: 150px">
							<img slot="reference" :src=changeImgURL(images.row.image) style="width: 30px;height: 30px">
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column property="cusCode" :label="$t('sellerpurchase').cusCode"  :show-overflow-tooltip="true"></el-table-column>
				<el-table-column property="variantName" label="sku"  :show-overflow-tooltip="true"></el-table-column>
				<!-- <el-table-column property="anotherName" label="商品别名" width="100" :show-overflow-tooltip="true"></el-table-column> -->
				<el-table-column property="print_num" :label="$t('sellerpurchase').Purchase_quantity"  :show-overflow-tooltip="true"></el-table-column>
				<el-table-column  :label="$t('processed.printingquantity')" show-overflow-tooltip width="250">
					<template slot-scope="scope">
						<el-input-number size="mini" style="width: 120px;"   :min="1"  v-model="scope.row.variantNum" ></el-input-number>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>
		
		<el-dialog :title="$t('sellerpurchase').Purchase_information" :visible.sync="auditTableVisible" width="80%">
			<div style="height: 450px;">
				<el-container>
					<el-aside width="50%" >
						<div>
							<el-row>
								<el-col :span="12">
									<div>
										{{$t('sellerpurchase').rukudanghao}}：{{itemDetailAudit.purchaseOrderId}}
									</div>
								</el-col>
								<el-col :span="12">
									<div>
										{{$t('sellerpurchase').create_time}}：{{handle(itemDetailAudit.createTime)}}
									</div>
								</el-col>
							</el-row>
							<el-row>
								<el-col :span="12">
									<div class="copw">
										{{$t('sellerpurchase').rukustore}}： {{showStore(itemDetailAudit.storeId)}}
									</div>
								</el-col>
								<el-col :span="12" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
									<el-tooltip class="item" effect="dark" :content="itemDetailAudit.messageToSeller" placement="left-end">
											  <div class="message-box">
												  {{$t('sellerpurchase').sellerMessage}}：{{itemDetailAudit.messageToSeller}}
											  </div>
									 </el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div>
							<el-table :data="itemDetailAudit.variantList" height="300px" border>
								<el-table-column  :show-overflow-tooltip="true">
									<template slot-scope="images">
										<el-popover placement="top-start" title="" trigger="hover">
											<img :src=changeImgURL(images.row.image) alt="" style="width: 150px;height: 150px">
											<img slot="reference" :src=changeImgURL(images.row.image) style="width: 30px;height: 30px">
										</el-popover>
									</template>
								</el-table-column>
								<el-table-column property="itemName" :label="$t('sellerpurchase').name"  :show-overflow-tooltip="true"></el-table-column>
								<el-table-column property="variantName" label="sku"  :show-overflow-tooltip="true"></el-table-column>
								<el-table-column property="anotherName" :label="$t('sellerpurchase').anthoeName"  :show-overflow-tooltip="true"></el-table-column>
								<el-table-column property="variantNum" :label="$t('sellerpurchase').Purchase_quantity"  :show-overflow-tooltip="true"></el-table-column>
							</el-table>
						</div>
					</el-aside>
					<el-main width="50%">
						<div>
							<el-row>
								<el-col :span="12">
									<div>
										{{$t('sellerpurchase').rukushuliangcomfirm}}
									</div>
								</el-col>
								<el-col :span="12">
									<div v-show="isAudited">
										{{$t('sellerpurchase').confirm_time}}：{{handle(itemDetailCopy.deliveredTime)}}
									</div>
								</el-col>
							</el-row>
							<el-row>
								<el-col :span="12">
									<div class="copw">
										{{$t('sellerpurchase').rukustore}}：{{showStore(itemDetailCopy.storeId)}}
									</div>
								</el-col>
								<el-col :span="12">
									
									<el-tooltip v-show="isAudited" class="item" effect="dark" :content="itemDetailCopy.messageToSeller" placement="left-end">
										<div class="message-box">
											{{$t('sellerpurchase').storeMessage}}：{{itemDetailCopy.messageToSeller}}
										</div>
									</el-tooltip>
									
								</el-col>
							</el-row>
						</div>
						<div>
							<el-table :data="itemDetailCopy.variantList" height="300px" border>
								<el-table-column  >
									<template slot-scope="images">
										<el-popover placement="top-start" title="" trigger="hover">
											<img :src=changeImgURL(images.row.image) alt="" style="width: 150px;height: 150px">
											<img slot="reference" :src=changeImgURL(images.row.image) style="width: 30px;height: 30px">
										</el-popover>
									</template>
								</el-table-column>
								<el-table-column property="itemName" :label="$t('sellerpurchase').name"  :show-overflow-tooltip="true"></el-table-column>
								<el-table-column property="variantName" label="sku"  :show-overflow-tooltip="true"></el-table-column>
								<el-table-column property="anotherName" :label="$t('sellerpurchase').anthoeName" :show-overflow-tooltip="true"></el-table-column>
								<el-table-column :label="$t('sellerpurchase').actualNo" width="155">
									<template scope="scope">
										<div v-show="isAudited">{{scope.row.variantNum}}</div>
										<el-input-number size="mini" :step="1" v-model="scope.row.variantNum" v-show="!isAudited"></el-input-number>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</el-main>
				</el-container>
				<el-row>
					<el-col :span="18">
						<div>
							<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" :placeholder="$t('sellerpurchase').tosellermsg" v-model.lazy="itemDetailCopy.messageToSeller"
							 resize="none" v-show="!isAudited">
							</el-input>
							&nbsp
						</div>
					</el-col>
					<el-col :span="6" >
						<div style="padding-top: 10px;float: right;">
							<el-button type="primary" @click="commitAudit" v-show="!isAudited">{{$t('sellerpurchase').sub}}</el-button>
							<el-button type="primary" @click="auditTableVisible=false" v-show="isAudited" style="float: right;">{{$t('sellerpurchase').I_know}}</el-button>
						</div>
					</el-col>
				</el-row>
			</div>
		</el-dialog>
		<div class="purchase_title">
			{{$t('homeTwo.Stockreceipt')}} 
		</div>
		<el-container>
			<el-header>
				<div class="purchase-header">
					<el-row>
						<el-col :span="3">
							<div style="width:150px;">
								<el-select @change="chooseStore" v-model="iSstore" >
									<el-option v-for="ppo in storeAll" :key="ppo.value" :label="ppo.label" :value="ppo.value">
									</el-option>
								</el-select>
							</div>
						</el-col>
						<el-col :span="3">
							<div style="width: 150px;">
								<el-select @change="chooseOrder" v-model="OrderStatus" >
									<el-option v-for="stat in statusAll" :key="stat.value" :label="stat.label" :value="stat.value">
									</el-option>
								</el-select>
							</div>
						</el-col>

						<el-col :span="3">
							<div style="width: 150px;">
								<el-select @change="chooseOrder" v-model="sellerId" >
									<el-option v-for="stat in btnList" :key="stat.value" :label="stat.label" :value="stat.value">
									</el-option>
								</el-select>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="search-box">
								<el-input style="width: 200px;"  :placeholder="$t('sellerpurchase').Warehousing" v-model="purchaseNo" clearable>
								</el-input>
								<el-button  @click="getPurchaserData">{{$t('sellerpurchase').Find}}</el-button>
							</div>
						</el-col>
					

						<el-col :span="3">
							<div >
								<el-button  type="primary" @click="scanProduct()">{{$t('processed.Scanincoming')}} </el-button>
							</div>
						</el-col>
					</el-row>
				</div>
			</el-header>
			<el-main>
				<div class="purchase-main">
					<template>
						<el-table :data="purchaseorderList"  border>
							<el-table-column prop="purchaseOrderId" :label="$t('sellerpurchase').order_number" width="120">
							</el-table-column>
							<el-table-column prop="userId" :label="$t('processed.Thesellerside')">

								<template scope="scope">
									<div style="font-size:14px;font-weight:bold">{{scope.row.purchaseOrderId}}</div>
									<div :class="{'checked':scope.row.orderFlag == 'SELLER_AUDITED', 'notchecked': scope.row.orderFlag !== 'SELLER_AUDITED'}">{{getStatusLable(scope.row.orderFlag)}}</div>
									
								</template>
							</el-table-column>
							<!-- <el-table-column prop="userId" label="卖家方" >
								<template scope="scope">
									{{showUserNameByuserId(scope.row.userId)}}
								</template>
							</el-table-column> -->
							<el-table-column :label="$t('sellerpurchase').Creation_time" width="250">
								<template slot-scope="scope">
									<div>{{$t('other.a57')}}：{{getTime01(scope.row.createTime)}}</div>
									<div>{{$t('other.a1532')}}：{{getTime01(scope.row.dateOfShip)}}</div>
									<div>{{$t('other.a1533')}}：{{getTime01(scope.row.deliveredTime)}}</div>
									<div>{{$t('other.a1529')}}：{{scope.row.orderFlag == 'SELLER_AUDITED' ? getTime01(scope.row.updateTime) : $t('other.a354')}}</div>
								</template>
							</el-table-column>
							
							<el-table-column :label="$t('sellerpurchase').Warehouse" width="160" :show-overflow-tooltip="true">
								<template slot-scope="scope">
									<div>{{showUserNameByuserId(scope.row.userId)}}</div>
									<div style="margin-top:20px">{{showStore(scope.row.storeId)}}</div>
								</template>
							</el-table-column>
							<el-table-column prop="quantity" :label="$t('sellerpurchase').country" >
								
							</el-table-column>
							<el-table-column prop="totaoVolumn" :label="$t('processed.Estimatedvolume')" >
								<template slot-scope="scope">
									<span>{{scope.row.totaoVolumn.toFixed(2)}}/m³</span>
								</template>
							</el-table-column>
							<el-table-column prop="messageToSeller" :label="$t('sellerpurchase').message" :show-overflow-tooltip="true">
							</el-table-column>
							<el-table-column fixed="right" :label="$t('sellerpurchase').operating" width="250">
								<template slot-scope="scope">
									<!-- <el-button @click="lookVariant(scope.row)" type="text" size="small">{{$t('sellerpurchase').View_items}}</el-button> -->
									<el-button v-show="scope.row.orderFlag == 'SELLER_AUDITED'"  @click="lookVariantCopy(scope.row)" type="text" size="small">{{$t('processed.viewdetails')}}</el-button>
									<el-button @click="auditPurchase(scope.row)" v-show="scope.row.orderFlag =='UNAUDITED'" style="color:red" type="text" size="small" >{{$t('sellerpurchase').check}}</el-button>
									<!-- <el-button  v-show="scope.row.orderFlag =='STORE_AUDITED'"  type="text" size="small" >{{$t('other.a1064')}}</el-button> -->
									<el-button @click="jumpBarcodePage(scope.row)"  type="text" size="small" >{{$t('homeTwo.Printbarcode')}}</el-button>
									<el-button @click="exportXml(scope.row)"  type="text" size="small" >{{$t('processed.Guidethe')}}</el-button>
									<!-- <el-button @click="removePurchase(scope.row)" type="text" size="small" v-show="scope.row.orderFlag=='UNAUDITED'">{{$t('sellerpurchase').delet}}</el-button>
									<el-button @click="auditPurchase(scope.row)" type="text" size="small" v-show="scope.row.orderFlag=='STORE_AUDITED'">{{$t('sellerpurchase').comfirm}}</el-button> -->
								</template>
							</el-table-column>
						</el-table>
					</template>
				</div>
			</el-main>
		</el-container>
		<!-- 分页器 -->
		<div class="Pager">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
			 :page-sizes="[10,30,50]" :page-size="30" layout="total, sizes, prev, pager, next, jumper" :total="pruchaseTotal">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import api from '../../api/api.js'
	import utils from '../../utils/utils.js'
	import {
		mapState,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				description:this.$t("allorders.description"),
				itemnum:this.$t("allorders.item"),
				setmeal:this.$t("allorders.setmeal"),
				OrderStatus: 0,
				userId: JSON.parse(localStorage.getItem('userInfo')).userId,
				iSstore: '',
				statusAll: [{
					value: 0,
					stus: '',
					label: this.$t('sellerpurchase').All_inbound_orders
				}, {
					value: 1,
					stus: 'UNAUDITED',
					label: this.$t('sellerpurchase').wait_store_check
				}, {
					value: 2,
					stus: 'STORE_AUDITED',
					label: this.$t('sellerpurchase').wait_check_in
				}, {
					value: 3,
					stus: 'SELLER_AUDITED',
					label: this.$t('sellerpurchase').aleady_check_in
				}],
				storeAll: [{
					value: '',
					label: this.$t('sellerpurchase').All_warehouses
				}, ],
				shopid: JSON.parse(localStorage.getItem('shopId')),
				orderList: [],
				userInfo: JSON.parse(localStorage.getItem('userInfo')),
				allStore: JSON.parse(localStorage.getItem('warehouse')),
				itemDetail: [],
				dialogTableVisible: false,
				auditTableVisible: false,
				printDetail:[],
				allStoreId:JSON.parse(localStorage.getItem('userInfo')).storeIds,
				userId:JSON.parse(localStorage.getItem('userInfo')).userId,
				rukuOrder:[],
				barCodeTrue:false,
				multipleSelection:[],
				rowData: [],
				itemDetailAudit: {
					store: {}
				},
				itemDetailCopy: {
					store: {}
				},
				dialogVisible: false,
				visiableMessage: '',
				purchaseNo: '',
				offset: 30,
				currentPage: 0,
				seller: '',
				isAudited:false,
				btnList:[],
				sellerId:null
			}
		},
		computed: {
			...mapState({
				purchaseorderList: state => state.sellerpurchase.purchaseorderList,
				pruchaseTotal: state => state.sellerpurchase.pruchaseTotal,
			}),

		},
		watch: {
			purchaseNo() {
				if (this.purchaseNo === "")
					this.getPurchaserData();
			},

		},
	
		created() {
			this.getBtnList()
			this.getPurchaserData();
			this.yui()
		},
		methods: {
			...mapActions('sellerpurchase', [
				'getPurchaseOrder',
				'removePurchaseOrder',
				'getPurchaseOrderNum'
			]),

			showUserNameByuserId(id){
				let sellers=JSON.parse(localStorage.getItem('userInfo')).sellers
				let obj=sellers.find(item => item.userId == id )
				if(obj){
					return obj.userId +  '(' + obj.userName + ')'
				}else{
					return id
				}
			},
			
			getBtnList(){
				
				let sellers=JSON.parse(localStorage.getItem('userInfo')).sellers
			

				this.btnList=sellers.map(p => {
					return {
						label:p.userName,
						value:p.userId
					}
				})

				this.btnList.unshift({
					label:this.$t('other.a1571'),
					value:null
				})



				console.log('btnList',this.btnList)
				

			},

			handleSelectionChange(val) {
			this.multipleSelection = val
			console.log(this.multipleSelection)
			
			},

			showStoreNameById(id){
				return utils.showstoreNameBystoreId(id)
			},
			printPurchaseCode(){
				console.log(this.rukuOrder)
				let obj=[{
					storeId:this.showStoreNameById(this.rukuOrder.storeId),
					messageToSeller:this.rukuOrder.messageToSeller,
					purchaseOrderId:this.rukuOrder.purchaseOrderId,
					dateOfShip:this.rukuOrder.dateOfShip,
					quantity:this.rukuOrder.quantity,
					height:80,
					width:320,
					flag:'1'
				}]

				console.log(obj)
				let routeData = this.$router.resolve({
					name: "purchaseBarcode",
					query:{
						data:JSON.stringify(obj)
					}
				});
				window.open(routeData.href, '_blank');
			},

			getBarCode(){
				if(this.multipleSelection.length==0){
					this.$message.error(this.$t('other.a1541'))
					return
				}
                let arr=this.multipleSelection.map(p => {
                    return  {
                       items:{
						    content:p.cusCode,
							height:80,
							width:320,
					   },
					   itemSku:p.variantName,
					   num:p.variantNum
                    }
                })
				utils.settUserAtt({
					attribute:JSON.stringify({
						data:JSON.stringify(arr),
						purchaseOrderId:this.rukuOrder.purchaseOrderId,
						storeId:this.rukuOrder.storeId
						
					}),
					userId:this.userId
				})
                console.log(arr)
					let routeData = this.$router.resolve({
					name: "barCode",
					
				});
				window.open(routeData.href, '_blank');
            },

			jumpBarcodePage(row){
				console.log(row)
				this.printDetail = row.variantList;
				this.rukuOrder=row
				this.printDetail.forEach(p => {
					p.print_num=p.variantNum
				})
				this.barCodeTrue = true;
				
			},

			showStore(id){
				return utils.showstoreNameBystoreId(id)
			},
			
			handle(date){
				let ttp=utils.renderTime(date)
				return ttp
			},
			goToBinditems() {
				this.$router.push('/userStoreItems')
			},

			scanProduct(){
				const {href}=this.$router.resolve({
					name:'scanIntoStoreage',

				
				}) 
				window.open(href)

			},
			removePurchase(item) {
				if (item.orderFlag !== "UNAUDITED") {
					alert(this.$t('other.a1542'))
					return
				} else {
					console.log(item)
					this.removePurchaseOrder(item)
				}

			},
			commitAudit() {
				this.itemDetailCopy.create_time = '';
				let param = {
					order: this.itemDetailAudit,
					orderCopy: this.itemDetailCopy,
					userId:this.userId
				}
				
				param.order.variantList.forEach(p=>{
						p.storeItem=null
				})
				param.orderCopy.variantList.forEach(p=>{
						p.storeItem=null
				})

				console.log(param)
				api.auditPurchaseOrder(param).then(res => {
					if (res.code === 200) {
						console.log(res.data)
						this.showMessage(this.$t('other.a1572'))
						this.auditTableVisible = false
						this.queryOrderList()
						location.reload()
					}else{
						this.$message.warning(res.msg)
					}
				})
			},
			chooseStore() {
				if(!this.iSstore){
					this.getDataList.storeIds=this.allStoreId
				}else{
					this.getDataList.storeIds=[this.iSstore]
				}
				console.log(this.getDataList)
				
				this.getPurchaseOrder(this.getDataList)
			},
			chooseOrder() {
				this.getDataList.type=this.OrderStatus
				this.getDataList.sellerId=this.sellerId
				this.getPurchaseOrder(this.getDataList)

			},
			//控制每页显示订单条数
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.getDataList.offset = parseInt(`${val}`)
				this.handleCurrentChange()
			},
			//显示当前第几页
			handleCurrentChange(val) {
				let currentPage = (parseInt(`${val}`) - 1) * this.offset
				this.getDataList.page=currentPage ? currentPage : 0
				this.getPurchaseOrder(this.getDataList)
			},
			yui() {
				this.allStore.forEach(item => {
					let param = {
						value: item.storeId,
						label: item.storeName + "(" + item.userName + ")",
					}
					this.storeAll.push(param)
				})
				console.log(this.storeAll)
			},
			getPurchaserData() {
				this.getDataList = {
					offset: this.offset,
					page: 0,
					purchaseOrderId: this.purchaseNo,
					sellerId: this.sellerId,
					storeIds: this.allStoreId,
					type: this.type,
					userId: this.userInfo.userId
				}
				console.log(this.getDataList)
				this.getPurchaseOrder(this.getDataList)

			},
			queryOrderList() {
				api.getPurchaseOrderByUserId(this.userInfo.userId).then(res => {
					if (res.code === 200) {
						console.log(res.data)
						this.orderList = res.data;
					}
				})
			},
			auditCH() {
				api.auditCH(this.itemDetailAudit).then(res => {
					if (res.code === 200) {
						console.log(res.data)
						
						this.showMessage(this.$t('sellerpurchase').ok)
						this.auditTableVisible = false;
						this.queryOrderList();
					}
				})
			},
			showMessage(massage) {
				this.dialogVisible = true;
				this.visiableMessage = massage;
			},

			lookVariant(row) {
				this.isAudited = row.orderFlag == "SELLER_AUDITED" ? true : false
				// let hasComfire= row.orderFlag == "SELLER_AUDITED" ? true : false
				this.itemDetail = row.variantList;
				if(this.isAudited) {
					// this.itemDetailAudit = row;
					this.$router.push({path:'/check',query:{purchaserid:row.purchaseOrderId}})
					// this.itemDetailCopy = JSON.parse(JSON.stringify(row.copyOrder))
					// this.auditTableVisible = true;
					
				}else{
					this.dialogTableVisible = true;
				}
				console.log(row)
				
			},

			lookVariantCopy(item) {
				console.log('row',item)
				let list=item.variantList
				this.storeMessage=item.copyOrder.messageToSeller
				this.sellerMessage=item.messageToSeller
				item.copyOrder.variantList.forEach(p => {
					p.sellerQty=list.find(item => item.variantName == p.variantName && item.storeItem.cusCode == p.storeItem.cusCode).variantNum
				})
				console.log(item)
				if(item.orderFlag == "SELLER_AUDITED"){
					this.itemDetail=item.copyOrder.variantList
					this.dialogTableVisible=true
				}
				this.dialogTableVisible=true
				
			},
			getStatusLable(value) {
				return this.statusAll.find(status => {
					return status.stus == value
				}).label;
			},
			getTime(time) {
				if (!time) {
					return this.$t("other.a354")
				}
				let ttp = time.slice(0, time.indexOf('T'))
				let ccp = time.slice(time.indexOf('T') + 1, time.indexOf('.'))
				return ttp + ' ' + ccp

			},
			getTime01(time) {
				return utils.renderTime(time)
			
			},
			auditPurchase(row) {
				this.$router.push({path:'/check',query:{purchaserid:row.purchaseOrderId}})
				console.log(row)
				this.isAudited = row.orderFlag == "UNAUDITED" ? false : true
				this.itemDetailAudit = row;
				if (!this.isAudited) {
					this.itemDetailCopy = JSON.parse(JSON.stringify(this.itemDetailAudit))
					this.itemDetailCopy.messageToSeller = '';
				} else {
					this.itemDetailCopy = JSON.parse(JSON.stringify(row.copyOrder))
				}
				this.auditTableVisible = true;
			},
				exportXml(item){
				console.log(item)
				let arr=[]
				item.variantList.forEach(p => {
					arr.push({
						'purchaseOrderId':item.purchaseOrderId,
						'cusCode':p.cusCode,
						'Name':p.itemName,
						'variantName':p.variantName,
						'Qty':p.variantNum,
						'Total':item.quantity,
						'Length':p.packageLength,
						'Width':p.packageWidth,
						'Height':p.packageHeight,

					})
				})

				let list= ['purchaseOrderId','cusCode','Name','variantName','Qty','Total','Length','Width','Height',]
				let tip=item.purchaseOrderId
				utils.exPortEXml(arr,list,tip)
			},
			changeImgURL(url) {
				return url
			},
			toreplace(){
				this.dialogVisible=false
				this.getPurchaserData();
			}
		}
	}
</script>

<style scoped>
	/* .purchase {
		flex: 1;
		margin: 60px 0 0 235px;
	} */

	.purchase_title{
		font-size: 18px;
		font-weight: bold;
	}

	.purchase .purchase-header {
		margin:  10px 0;
	}

	.purchase .el-dialog__body {
		padding-top: 0px;
	}

	.purchase .el-main {
		padding-top: 0px;
		padding-left: 0px;

	}

	.purchase .Pager{
		position: fixed;
		bottom: 0;
		left: 205px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
		z-index: 89;
	}
	.purchase .checked{
		color:rgb(0, 199, 163);
		font-size: 14px;
		font-weight: bold;
	}
    .purchase .notchecked{
		color: rgb(255, 82, 69);
		font-size: 14px;
		font-weight: bold;
	}
	
	

	.purchase .el-table__body {
		width: 100%;
	}

	.purchase .el-header{
		padding:0;
		margin-top: 20px;
	}

	.purchase .el-table__body {
		width: 100%;
	}

	.purchase .el-table_1_column_2 {
		width: 180px;
	}

	.purchase .search-box {
		display: flex;
	}

	.purchase .Pager {
		float: right;
	}
	
	.purchase .message-box{
		
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.purchase .copw{
		width: 250px;
		overflow: hidden;
		text-overflow: ellipsis;
    	white-space: nowrap;
	}
	
	.purchase .message-box:hover{
		width: auto;
	}
</style>
